import { useState, useEffect } from "react";
import { DEFAULT_MASCOT_SRC } from "@/shared/constants/mascotCatalog";
import { MascotImage } from "./MascotSelector.styles";

interface MascotDisplayProps {
    src: string;
    label: string;
    isSelected: boolean;
    disableScale?: boolean;
    onClick?: () => void;
};

export const MascotDisplay: React.FC<MascotDisplayProps> = ({
    src,
    label,
    isSelected,
    disableScale,
    onClick
}) => {
    const [hasError, setHasError] = useState(false);

    useEffect(() => {
        setHasError(false);
    }, [src]);

    const handleError = () => {
        setHasError(true);
    };

    return (
        <MascotImage
            isSelected={isSelected}
            disableScale={disableScale}
            src={hasError ? DEFAULT_MASCOT_SRC : src}
            alt={label}
            aria-label={label}
            onClick={onClick}
            onError={handleError}
        />
    );
};